import Block from '../../common.blocks/block'

export default class AbleEye extends Block {
	static title = 'able-eye'

	constructor($el) {
		super($el)

		const getCookie = (name) =>
			document.cookie
				.split('; ')
				.find((row) => row.startsWith(name + '='))
				?.split('=')[1] || null
		const ableEyeCookie = getCookie('ableEye')

		if (ableEyeCookie) {
			this.activate()
		}

		this.$el.on('click', () => {
			this.$el.addModifier('hidden')

			this.data = new FormData()
			this.data.append('ajax', true)
			this.data.append('cookie', 'ableEye')
			this.data.append('cookie_expire', 'Session')

			$.ajax({
				method: 'POST',
				processData: false,
				contentType: false,
				cache: false,
				url: '/cookie',
				data: this.data,
			})

			this.activate()
		})
	}

	activate() {
		return import(/* webpackChunkName: 'eye-able' */ './eye-able')
			.then(({ default: activateEyeAble }) => activateEyeAble())
			.catch((error) => {
				// eslint-disable-next-line no-console
				console.error('able-eye: failed to load the Eye-Able loader', error)
			})
	}
}
